<template>
  <div>
    <div class="grid gap-4 py-6 border-t bg-gray-50 md:grid-cols-3 auto-rows-auto lg:grid-cols-5">
      <DatePicker class="md:col-span-2" color="indigo" mode="dateTime" :minute-increment="5" is-range is24hr v-model="filter.date" :model-config="{ start: { timeAdjust: '00:00:00' }, end: { timeAdjust: '23:59:59' } }">
        <template v-slot="{ inputValue, inputEvents }">
          <div class="flex justify-center">
            <input
              :value="inputValue.start"
              v-on="inputEvents.start"
              class="w-40 form-input prepend"
            />
            <div class="flex items-center justify-center flex-none w-10 border bg-gray-50">
              &rarr;
            </div>
            <input
              :value="inputValue.end"
              v-on="inputEvents.end"
              class="w-40 form-input append"
            />
          </div>
        </template>
      </DatePicker>
      <filter-dropdown button-class="" button-text="More Filters" :hide-buttons="true">
        <fieldset class="form-group">
          <label class="form-label">Breakdown by</label>
          <select name="" id="" class="form-select" v-model="filter.breakdown_by">
            <option value="driver">Driver</option>
            <option value="vehicle">Vehicle</option>
          </select>
        </fieldset>
        <fieldset class="form-group">
          <label for="filterZero" class="form-label">
            <input id="filterZero" type="checkbox" class="mt-0.5 mr-2 form-checkbox" v-model="filter.hide_zero_values">  
            Filter Out 0 Values
          </label>
        </fieldset>
      </filter-dropdown>
    </div>

    <template v-if="report">
      <div class="card">
        <div class="flex flex-col justify-between p-4 border-b md:flex-row lg:p-5">
          <button class="ml-auto btn btn-sm btn-outline" @click="$parent.downloadReport()" v-submitting="$parent.submitting">
            <fa :icon="['far', 'arrow-to-bottom']" class="mr-2" /> Download
          </button>
        </div>
        <data-table
          small
          :items="report.rows" 
          :keys="keys" />
      </div>
    </template>
  </div>
</template>

<script>
import { sub } from 'date-fns'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import FilterDropdown from '@/components/FilterDropdown'

export default {
  name: 'UsageTimeReport',

  components: {
    DatePicker,
    FilterDropdown
  },

  props: {
    report: {
      type: Object
    }
  },

  computed: {
    params () {
      return { 
        filter: this.filter
      }
    },

    keys () {
      let keys = []
      for (let key in this.report.rows[0]) {
        keys.push({ 
          name: key, 
          slug: key, 
          display: (val) => {
            if (Number(val.split(':')[0]) >= 14) { 
              return `<div class="text-red-600">${val}</div>`
            } else if (Number(val.split(':')[0]) >= 9) {
              return `<div class="text-yellow-600">${val}</div>`
            } else if (val === '00:00:00') {
              return `<div class="text-gray-400">${val}</div>`
            } else {
              return val
            }
          } 
        })
      }
      return keys
    }
  },

  data () {
    return {
      filter: {
        date: {
          start: sub(new Date(), { days: 1 }),
          end: new Date()
        },
        breakdown_by: 'driver',
        hide_zero_values: false
      }
    }
  }
}
</script>